function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M33.83 19.6602V47.1302C33.83 48.6154 33.24 50.0398 32.1898 51.09C31.1396 52.1402 29.7152 52.7302 28.23 52.7302H5.6C4.11479 52.7302 2.69041 52.1402 1.6402 51.09C0.589998 50.0398 0 48.6154 0 47.1302L0 16.2802C0 14.795 0.589998 13.3706 1.6402 12.3204C2.69041 11.2702 4.11479 10.6802 5.6 10.6802H24.74",
  fill: "#5FCAE4"
});

var _ref3 = /*#__PURE__*/React.createElement("path", {
  d: "M24.7402 10.6802L33.7402 19.6802H27.7402C26.9632 19.6802 26.2179 19.3715 25.6684 18.822C25.1189 18.2725 24.8102 17.5273 24.8102 16.7502L24.7402 10.6802Z",
  fill: "#4D74FC"
});

var _ref4 = /*#__PURE__*/React.createElement("path", {
  d: "M5.4707 29.0801H28.2507",
  stroke: "white",
  strokeLinecap: "round",
  strokeLinejoin: "round"
});

var _ref5 = /*#__PURE__*/React.createElement("path", {
  d: "M5.4707 33.6802H28.2507",
  stroke: "white",
  strokeLinecap: "round",
  strokeLinejoin: "round"
});

var _ref6 = /*#__PURE__*/React.createElement("path", {
  d: "M5.4707 38.3799H28.2507",
  stroke: "white",
  strokeLinecap: "round",
  strokeLinejoin: "round"
});

var _ref7 = /*#__PURE__*/React.createElement("path", {
  d: "M5.4707 42.98H19.1107",
  stroke: "white",
  strokeLinecap: "round",
  strokeLinejoin: "round"
});

var _ref8 = /*#__PURE__*/React.createElement("path", {
  d: "M35.0392 15.18C39.093 15.18 42.3792 11.8938 42.3792 7.84C42.3792 3.78623 39.093 0.5 35.0392 0.5C30.9854 0.5 27.6992 3.78623 27.6992 7.84C27.6992 11.8938 30.9854 15.18 35.0392 15.18Z",
  fill: "#EEFFFF",
  stroke: "#5872C6",
  strokeLinecap: "round",
  strokeLinejoin: "round"
});

var _ref9 = /*#__PURE__*/React.createElement("path", {
  d: "M35.0391 2.58008V12.6501",
  stroke: "#5872C6",
  strokeLinecap: "round",
  strokeLinejoin: "round"
});

var _ref10 = /*#__PURE__*/React.createElement("path", {
  d: "M29.7793 7.62012H40.2893",
  stroke: "#5872C6",
  strokeLinecap: "round",
  strokeLinejoin: "round"
});

function SvgEmptyPlexes(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 43,
    height: 53,
    viewBox: "0 0 43 53",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2, _ref3, _ref4, _ref5, _ref6, _ref7, _ref8, _ref9, _ref10);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgEmptyPlexes);
export default __webpack_public_path__ + "static/media/empty_plexes.d2c228ce.svg";
export { ForwardRef as ReactComponent };